import { LOGIN, LOGOUT, SIGNUP } from 'Constants'

export default function(
  state = localStorage.getItem('customerkey') !== null,
  action
) {
  switch (action.type) {
    case LOGIN:
      return localStorage.getItem('customerkey') !== null
    case SIGNUP:
      return localStorage.getItem('customerkey') !== null
    case LOGOUT: {
      // Save the aws-waf-token before clearing
      const awsWafToken = localStorage.getItem('aws-waf-token')
      const displayTimezone = localStorage.getItem('bookee_display_tz')
      localStorage.clear()
      // Restore the aws-waf-token
      if (awsWafToken) {
        localStorage.setItem('aws-waf-token', awsWafToken)
      }
      if (displayTimezone === 'local' || displayTimezone === 'studio') {
        localStorage.setItem('bookee_display_tz', displayTimezone)
      }
      return false
    }
    default:
      return state
  }
}
